import LayoutStore from '../stores/layout-store';

export const toggleTheme = (): void => {
  const targetTheme = LayoutStore.themeType === 'dark' ? 'light' : 'dark';
  LayoutStore.themeType = targetTheme;
  localStorage.setItem('theme', targetTheme);
};
